export default __webpack_public_path__ + "static/media/activmq.12865df2.png";